/**
 * Created by emanuele on 31/01/2017.
 */
import React from 'react';
import LocalNumber from './LocalNumber';
import PropTypes from 'prop-types';
const ShowLocalNumber = ({ value, type }) => {

    return <div><LocalNumber value={value} type={type}/></div>
}

ShowLocalNumber.PropTypes = {
    value: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
}

ShowLocalNumber.defaultProps = {
    type: 'decimal'
};

export default ShowLocalNumber;


/** WEBPACK FOOTER **
 ** ./src/components/ShowLocalNumber.jsx
 **/